<template>
    <ValidationObserver ref="form">
        <h3 class="profile__ttl">Passport Information:</h3>
        <div class="row mb-4">
            <ValidationProvider
                class="col-md-6"
                name="Legal Name"
                v-slot="{ errors }"
                rules="required|min:3|latin"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Legal Name (Exactly as it appears in your passport)</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="passportInfo.legal_name"
                    >
                    <FormError :error="errors[0]" name="Legal Name"/>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="Passport Number"
                v-slot="{ errors }"
                rules="required|min:6"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Passport Number</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="passportInfo.number"
                    >
                    <FormError :error="errors[0]" name="Passport Number"/>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="Passport Date of Issue"
                v-slot="{ errors }"
                rules="required"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Passport Date of Issue</label>
                    <input
                        type="date"
                        class="form-control pl-4"
                        v-model="passportInfo.date_of_issue"
                    >
                    <FormError :error="errors[0]" name="Passport Date of Issue"/>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="Passport Date of Expiry"
                v-slot="{ errors }"
                rules="required"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Passport Date of Expiry</label>
                    <input
                        type="date"
                        class="form-control pl-4"
                        v-model="passportInfo.date_of_expiry"
                    >
                    <FormError :error="errors[0]" name="Passport Date of Expiry"/>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="Passport Nationality"
                v-slot="{ errors }"
                rules="required|min:3|latin"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Passport Nationality (Country of issue)</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="passportInfo.nationality"
                    >
                    <FormError :error="errors[0]" name="Passport Nationality"/>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="Passport Authority"
                v-slot="{ errors }"
                rules="required|min:3"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Passport Authority (Place of issue)</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="passportInfo.place_of_issue"
                    >
                    <FormError :error="errors[0]" name="Passport Authority"/>
                </div>
            </ValidationProvider>
        </div>
    </ValidationObserver>
</template>

<script>

import FormError from "../Common/FormError.vue";
import {mapState} from "pinia";
import {useArtistStore} from "../../stores/ArtistStore";

export default {
    name: 'ArtistPassportInformation',
    components: {FormError},
    watch: {
        passportInfo: {
            handler(state) {
                this.dispatchState(state);
            },
            deep: true
        }
    },
    mounted() {
        this.dispatchState(this.passportInfo);
    },

    computed: {
        ...mapState(useArtistStore, {
            passportInfo: 'passportInfo',
        }),
    }
}

</script>



<style scoped>

</style>
